<template>
  <CustomPage :noTitle="true">
    <template slot="content">
      <div class="searchpage">
        <form action="/">
          <Search
            id="searchbar"
            v-model="value"
            v-focus
            show-action
            shape="round"
            placeholder="搜索"
            @search="onSearch"
            @cancel="onCancel"
          >
            <template #left-icon>
              <Icon name="search" color="red" />
            </template>
          </Search>
        </form>
        <div class="px-2">
          <div v-show="searchHeatList.length">
            <div class="font-semibold text-sm text-left">大家都在搜</div>
            <div class="text-left flex flex-wrap">
              <div
                v-for="(i, idx) in searchHeatList"
                :key="idx"
                class="text-xs rounded-full px-3 py-1 mr-1 my-1"
                style="background-color: #f1f1f1"
                @click="onSearch(i)"
              >
                {{ i }}
              </div>
            </div>
          </div>
          <div v-show="goodsHistoryList.length">
            <div class="font-semibold text-sm text-left mt-3">历史搜索</div>
            <div class="text-left flex flex-wrap">
              <div
                v-for="(i, idx) in goodsHistoryList"
                :key="idx"
                class="text-xs rounded-full px-3 py-1 mr-1 my-1"
                style="background-color: #f1f1f1"
                @click="onSearch(i, 're')"
              >
                {{ i }}
              </div>
            </div>
          </div>
          <!-- 到时候在下面改一下数据以及写点样式渲染就可以了 写两个新组件 -->
          <div v-show="hotBrandList.length">
            <div class="font-semibold text-sm text-left mt-3">热门品牌推荐</div>
            <div
              class="brand-list flex overflow-scroll overflow-x-auto"
              style="scrollbar-color: red yellow"
            >
              <BrandCard
                v-for="(brand, idx) in hotBrandList"
                :key="idx"
                width="55"
                height="55"
                round
                lazy-load
                @click="
                  $router.push({
                    name: 'BrandPlace',
                    params: { partId: brand.partId },
                  })
                "
                :title="brand.brandName"
                :src="brand.brandLogo"
              />
            </div>
          </div>
          <div v-show="recommendGoodsList.length">
            <div class="font-semibold text-sm text-left mt-3">热门商品推荐</div>

            <masonry-wall
              class="p-2"
              :items="recommendGoodsList"
              :column-width="163"
              :gap="10"
            >
              <template #default="{ item, index }">
                <GoodsCard
                  v-if="defer(2)"
                  fit="fill"
                  :key="index"
                  :data="item"
                  lazy-load
                ></GoodsCard>
              </template>
            </masonry-wall>

            <!-- <GoodsCard
                class="card-layout"
                v-for="(goods, idx) in recommendGoodsList"
                fit="fill"
                :key="idx"
                :data="goods"
              ></GoodsCard> -->
            <!-- :coupons="[{ couponName: '满100减10' }]" -->
            <!-- goodsCard 已隐藏 tips tag ，若需要请传递 类似下面结构的数据到组件 -->
            <!-- :coupons="[{ couponName: '满100减10' }]" -->
            <!-- activityReward: 'COMMISSION', -->

            <!-- <GoodsCard
                class="card-layout"
                v-for="value in 20"
                :key="value"
                :data="{
                  activityReward: 'NEWBIE',
                  goodsImage:
                    'https://images.unsplash.com/photo-1490645935967-10de6ba17061',
                  goodsName:
                    'onepisya\'s goods as丁发窘开了发三矿扥卡萨来就疯狂矮三分顶啦三菱发ccccccccsdkfjaskdfjaskdfjkalsdjfklasjdklfasjdklfajslkdfjklasdjfklasdfjklasccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccc',
                  linePrice: 100,
                  actPrice: 90,
                  buyQuantity: 99,
                  start: '2022-08-02T00:00:00',
                  end: '2022-08-09T00:00:00',
                }"
                :coupons="[{ couponName: '满100减10' }]"
              ></GoodsCard> -->
          </div>
        </div>
        <CustomView />
      </div>
    </template>
  </CustomPage>
</template>

<script>
import { Search, Icon } from "vant";
import BrandCard from "@/components/card/BrandCard.vue";
import GoodsCard from "@/components/card/GoodsCard.vue";
import CustomView from "@/components/custom-view.vue";
import CustomPage from "@/components/custom-page.vue";
import { getSearchWords } from "./webApi";
import { getHotWords, getHotBrand, getHotGoods } from "@/api/searchSetting";
import Defer from "@/mixins/defer";

export default {
  components: { Search, Icon, CustomView, CustomPage, BrandCard, GoodsCard },
  mixins: [Defer()],
  created() {
    this.value = this.$route.params.text;
    getSearchWords().then(({ data }) => {
      this.goodsHistoryList = data.goodsHistoryList;
    });
    getHotWords().then((res) => {
      this.searchHeatList = res.data;
    });
    getHotBrand().then((res) => {
      console.log(res, "brand");
      this.hotBrandList = res.data;
    });
    getHotGoods().then((res) => {
      console.log(res, "goods");
      this.recommendGoodsList = res.data;
    });
  },
  mounted() {},
  data() {
    return {
      value: "",
      searchHeatList: [],
      goodsHistoryList: [],
      hotBrandList: [],
      recommendGoodsList: [],
    };
  },
  methods: {
    onSearch(val, re) {
      if (val.trim()) {
        this.value = val;
        if (re !== "re") {
          this.goodsHistoryList.unshift(val);
        }
        this.$router.push({
          name: "SearchResult",
          params: {
            text: val,
          },
        });
      } else {
        document.getElementById("searchbar").focus();
      }
    },
    onCancel() {
      this.$router.back();
    },
  },
  beforeRouteUpdate(to, from, next) {
    if (from.name === "SearchResult") {
      // document.getElementById("searchbar").focus();
    }
    next();
  },
  directives: {
    focus: {
      // 指令的定义
      componentUpdated(el) {
        let _input = el.querySelector("#searchbar");
        setTimeout(() => {
          _input.focus();
        }, 600);
      },
      update(el) {
        let _input = el.querySelector("#searchbar");
        setTimeout(() => {
          _input.focus();
        }, 600);
      },
    },
  },
};
</script>

<style lang="less" scoped>
.van-grid-item__content {
  padding: 0;
  margin: 10px;
  justify-content: start;
}
.brand-list::-webkit-scrollbar {
  color: transparent;
}
.grid-goods-card {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  /* px-to-viewport-ignore-next */
  grid-auto-rows: minmax(0px, 1fr);
  /* px-to-viewport-ignore-next */
  gap: 10px;
  align-items: end;
  /* dense 属性 会自动 将  空出来的 空间填满 */
  .card-layout {
    grid-column: auto / span 1;
    grid-row: auto/ span 1;
  }
}
</style>

